import React, { Component } from 'react';
import { Container, Row, Col, Button, Form, FormGroup, Label, Input, ListGroup, ListGroupItem } from 'reactstrap';
import { compose, graphql } from 'react-apollo';
import { purchaseDay } from "../../graphqlDic";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import { callChange } from './../../helpers/ApiPayment';

class PurchaseDay extends Component {
    constructor(props) {
        super(props)
        this.state = {
            package_purchase: [],
            package_selected: null
        }
    }

    notify = (msg) => toast.info(msg);

    handleOnChane = (e) => {
        let target = e.target;
        if (target.name === "package_purchase") {
            let package_selected = null;
            for (let item of this.state.package_purchase) {
                if (parseInt(item.id, 10) === parseInt(target.value, 10)) {
                    package_selected = item
                }
            };
            this.setState({
                package_selected: package_selected
            })
        }
    }

    handleSubmit = () => {
        let { package_selected } = this.state;
        let { user_info } = this.props;

        if (package_selected) {
            if (user_info.scoin >= package_selected.scoin) {
                this.props.purchaseDay({
                    variables: {
                        user_id: parseInt(user_info.id, 10),
                        package_purchase_day_id: parseInt(package_selected.id, 10),
                    }
                }).then(() => {
                    let data = {};
                    data.email = user_info.email;
                    data.value = -Math.abs(package_selected.scoin); // negative-number
                    data.ordercode = Date.now();
                    let result = callChange(data);
                        result.then(
                            window.location.reload()
                        ).catch(console.log)
                })
                .catch(error => {
                    console.log(error)
                });
               
            }
            else {
                this.notify("Tài khoản của bạn không đủ scoin!");
            }

        } else {
            this.notify("Mời bạn chọn số ngày cần mua");
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            package_purchase: nextProps.getPackagePurchaseDay.getPackagePurchaseDay
        })
    }

    componentWillMount() {
        this.setState({
            package_purchase: this.props.getPackagePurchaseDay.getPackagePurchaseDay
        });
    }

    generatePackagePurchase = (package_purchase) => {
        return [...package_purchase].map((item, index) => {
            return <option key={index} value={item.id}>{item.day + " ngày - " + item.scoin + " scoin"}</option>
        })
    }

    render() {
        if (this.props.getPackagePurchaseDay.loading) return "Loading...";
        if (this.props.getPackagePurchaseDay.error) return `Error! ${this.props.getPackagePurchaseDay.error.message}`;
        let { package_purchase } = this.state;
        let { user_info } = this.props;
        if (JSON.stringify(user_info) === '{}') {
			return 'Loadding...';
        }

        return (
            <div className="pt-8">
                <Container>
                    <Row>
                        <Col>
                            <ToastContainer />
                            <Form>
                                <div className="text-uppercase user-info-heading"><i className="fa fa-lg fa-check-square text-danger"></i>{' '}Thông tin tài khoản</div>
                                <ListGroup>
                                    {user_info.endday ? <ListGroupItem>
                                        <strong>- THỜI GIAN KẾT THÚC: </strong>
                                        <span className="text-danger">{new Date(user_info.endday).toLocaleString()}</span>
                                    </ListGroupItem>
                                        : null}
                                    <ListGroupItem><strong>- SỐ DƯ TÀI KHOẢN: </strong><span className="text-danger">{user_info.scoin} scoin</span></ListGroupItem>
                                </ListGroup>
                                <FormGroup>
                                    <Label for="package_purchase">Số ngày bạn muốn mua</Label>
                                    <Input
                                        type="select"
                                        name="package_purchase"
                                        multiple={false}
                                        id="package_purchase"
                                        onChange={this.handleOnChane}
                                    >
                                        <option value={-1}>{"Mời bạn chọn số ngày cần mua"}</option>
                                        {this.generatePackagePurchase(package_purchase)}
                                    </Input>
                                </FormGroup>
                                <Button outline color="success" onClick={this.handleSubmit} className="do-action">mua</Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user_info: state.root.users
    }
}

export default compose(graphql(
    purchaseDay, {
        name: 'purchaseDay'
    })
)(connect(mapStateToProps, null)(PurchaseDay));


// WEBPACK FOOTER //
// ./src/components/Scoin/PurchaseDay.js